import { render, staticRenderFns } from "./ViewTestQuestionsPracticeTest.vue?vue&type=template&id=01b68701&scoped=true"
import script from "./ViewTestQuestionsPracticeTest.vue?vue&type=script&lang=js"
export * from "./ViewTestQuestionsPracticeTest.vue?vue&type=script&lang=js"
import style0 from "./ViewTestQuestionsPracticeTest.vue?vue&type=style&index=0&id=01b68701&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b68701",
  null
  
)

export default component.exports